export default __webpack_public_path__ + "img/Legacy.19751f2b.png";